import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import AddNewBooking from './AddNewBooking';
import './NewBookingModal.css';

/**
 * The New Booking form as a pop-up over the Booking Management listing.
 *
 * Clicking outside does not close it, so a half-taken phone booking is not
 * lost to a stray click; the ✕ does.
 */
export default function NewBookingModal({ show, onHide, onCreated }) {
  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" className="nb-modal" backdropClassName="nb-backdrop" enforceFocus={false}>
      {/* The View Booking popup's header: cream ground with a mint corner,
          yellow dot and sand curve, a green icon tile and a red ✕. */}
      <div className="nb-head">
        <span className="nb-head__glow" aria-hidden="true" />
        <span className="nb-head__tile">
          <i className="ph ph-calendar-plus" />
        </span>
        <div className="nb-head__text">
          <h5 className="nb-head__title">New Booking</h5>
          <span className="nb-head__sub">Fill in the details below — the next fields open as you go</span>
        </div>
        <button type="button" className="nb-head__close" aria-label="Close" onClick={onHide}>
          <i className="ph ph-x" />
        </button>
      </div>

      <Modal.Body className="nb-body">
        {/* Remounted on each open, so every booking starts from a clean form. */}
        {show && <AddNewBooking inModal onCreated={onCreated} onCancel={onHide} />}
      </Modal.Body>
    </Modal>
  );
}

NewBookingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  /** Called once the booking is saved; the caller closes the pop-up and refreshes. */
  onCreated: PropTypes.func
};
